import React from "react";

const SlideShareIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.224"
      height="25.223"
      viewBox="0 0 25.224 25.223"
    >
      <g id="db39" transform="translate(-191.37 -191.37)">
        <path
          id="Path_1278"
          data-name="Path 1278"
          d="M203.981,191.37a12.611,12.611,0,1,0,12.612,12.611,12.611,12.611,0,0,0-12.612-12.611Zm7.857,13.709a7.373,7.373,0,0,1-2.7,1.92c-.328.144-.38.251-.291.6a4.718,4.718,0,0,1-.513,3.941,3.018,3.018,0,0,1-2.438,1.381,2.19,2.19,0,0,1-.673-.1,1.721,1.721,0,0,1-1.243-1.317,1.826,1.826,0,0,1-.432.811,1.959,1.959,0,0,1-1.466.612,2.584,2.584,0,0,1-.608-.075,3.234,3.234,0,0,1-2.453-2.885,11.034,11.034,0,0,1,.1-2.43c.041-.3-.012-.365-.277-.53-.652-.406-1.294-.847-1.914-1.275l-.616-.423a.575.575,0,0,1-.241-.279c-.016-.053-.036-.108-.056-.166a1.254,1.254,0,0,1-.108-.688c.046-.194.018-.24.3-.3.054-.011.141.092.141.08l-.038-1.935c0-1.267.059-2.557.06-3.824a1.873,1.873,0,0,1,2.044-1.943c3.635,0,7.335,0,10.97,0a1.747,1.747,0,0,1,1.9,1.831c.006,1.2.025,2.426.026,3.608,0,.681.01,1.362.013,2.043,0,.027,0,.064.007.11l.156.032c.282.057.506.1.551.3a1.146,1.146,0,0,1-.206.91Z"
          fill={fill ? fill : "#707070"}
        />
        <path
          id="Path_1279"
          data-name="Path 1279"
          d="M291.843,281.347a1.98,1.98,0,0,0-.279-.066h-.086c-3.172,0-6.344.05-9.516.051-.1,0-.242.049-.466.051a2.063,2.063,0,0,0-.62.013.9.9,0,0,0-.318.173.959.959,0,0,0-.26.375,1.572,1.572,0,0,0-.116.785v.365c0,1.684-.1,3.174-.077,4.886,0,.089.577.51.664.553a7.518,7.518,0,0,0,3.833.72c.133-.009.339-.019.513-.019a2.093,2.093,0,0,1,1.593.573,1.4,1.4,0,0,1,1.244-.6c.116,0,.252.007.408.021.253.023.509.035.757.035a7.729,7.729,0,0,0,3.355-.761.531.531,0,0,0,.238-.339c.026-2.04.028-3.95.007-5.789-.008-.677-.2-.929-.876-1.032Zm-6.086,6.493a2.129,2.129,0,0,1-1.5.614c-.016,0-.031,0-.047,0a2.2,2.2,0,1,1,.008-4.4h.016a2.283,2.283,0,0,1,2.154,2.18A2.353,2.353,0,0,1,285.757,287.84Zm5.142.078a2.341,2.341,0,0,1-1.565.756h-.028a2.252,2.252,0,0,1-2.191-2.221,2.206,2.206,0,0,1,2.182-2.113,2.176,2.176,0,0,1,2.21,2.108,2.09,2.09,0,0,1-.608,1.47Z"
          transform="translate(-82.673 -83.77)"
          fill={fill ? fill : "#707070"}
        />
      </g>
    </svg>
  );
};

export default SlideShareIcon;
